import ObjectIterator from './object_iterator';

export function getParamUrl(name, url) {
    if (!url) url = location.href;
    name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
    var regexS = "[\\?&]"+name+"=([^&#]*)";
    var regex = new RegExp( regexS );
    var results = regex.exec( url );
    return results == null ? null : results[1];
}

export function parseFromObject(object) {
	let queryStringArr = [];
	for(let [key, value] of ObjectIterator.iterate(object)) {
		queryStringArr.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
	}

	return queryStringArr.join("&");
}

export function parseFromObjectsArray(objectsArray, keyField="name", valueField="value") {
	let queryStringArr = [];
	objectsArray.forEach((object) => {
		queryStringArr.push(encodeURIComponent(object[keyField]) + "=" + encodeURIComponent(object[valueField]));
	});

	return queryStringArr.join("&");
}

export const QueryStringParser = {
	parseFromObject,
	parseFromObjectsArray
};

export default QueryStringParser;
